module.exports = __webpack_public_path__ + "img/wrdta.0ab759b3.jpg";